// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type CohortDetailsForFormQueryVariables = Types.Exact<{
  cohortId: Types.Scalars['ID']['input'];
}>;


export type CohortDetailsForFormQuery = { __typename?: 'Query', cohort: { __typename?: 'Cohort', id: string, name: string, isBoolDefaultForDevelopment?: boolean | null | undefined, market: { __typename?: 'Market', id: string, name: string }, development?: { __typename?: 'Development', id: string, name: string } | null | undefined, projects: Array<
      | { __typename?: 'StandaloneProject', id: string, name: string }
      | { __typename?: 'Region', id: string, name: string }
      | { __typename?: 'Market', id: string, name: string }
      | { __typename?: 'Community', id: string, name: string }
      | { __typename?: 'Subdivision', id: string, name: string }
      | { __typename?: 'Lot', id: string, name: string }
      | { __typename?: 'Structure', id: string, name: string }
      | { __typename?: 'Unit', id: string, name: string }
    > } };

export type PopulateCohortFormOptionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PopulateCohortFormOptionsQuery = { __typename?: 'Query', markets: Array<{ __typename?: 'Market', id: string, name: string }>, projects: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string, cohort?: { __typename?: 'Cohort', id: string } | null | undefined, market: { __typename?: 'Market', id: string } }
    | { __typename?: 'Region', id: string, name: string, cohort?: { __typename?: 'Cohort', id: string } | null | undefined, market?: { __typename?: 'Market', id: string } | null | undefined }
    | { __typename?: 'Market', id: string, name: string, cohort?: { __typename?: 'Cohort', id: string } | null | undefined, market: { __typename?: 'Market', id: string } }
    | { __typename?: 'Community', id: string, name: string, cohort?: { __typename?: 'Cohort', id: string } | null | undefined, market: { __typename?: 'Market', id: string } }
    | { __typename?: 'Subdivision', id: string, name: string, cohort?: { __typename?: 'Cohort', id: string } | null | undefined, market: { __typename?: 'Market', id: string } }
    | { __typename?: 'Lot', id: string, name: string, cohort?: { __typename?: 'Cohort', id: string } | null | undefined, market: { __typename?: 'Market', id: string } }
    | { __typename?: 'Structure', id: string, name: string, cohort?: { __typename?: 'Cohort', id: string } | null | undefined, market: { __typename?: 'Market', id: string } }
    | { __typename?: 'Unit', id: string, name: string, cohort?: { __typename?: 'Cohort', id: string } | null | undefined, market: { __typename?: 'Market', id: string } }
  > };

export type SaveCohortsMutationVariables = Types.Exact<{
  cohorts: Types.SaveCohortsInput;
}>;


export type SaveCohortsMutation = { __typename?: 'Mutation', saveCohorts: { __typename?: 'SaveCohortsResult', cohorts: Array<{ __typename?: 'Cohort', id: string, name: string, isBoolDefaultForDevelopment?: boolean | null | undefined, market: { __typename?: 'Market', id: string, name: string }, projects: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string, buildAddress: { __typename?: 'Address', id: string, street1: string } }
        | { __typename?: 'Region', id: string, name: string, buildAddress?: { __typename?: 'Address', id: string, street1: string } | null | undefined }
        | { __typename?: 'Market', id: string, name: string, buildAddress?: { __typename?: 'Address', id: string, street1: string } | null | undefined }
        | { __typename?: 'Community', id: string, name: string, buildAddress?: { __typename?: 'Address', id: string, street1: string } | null | undefined }
        | { __typename?: 'Subdivision', id: string, name: string, buildAddress?: { __typename?: 'Address', id: string, street1: string } | null | undefined }
        | { __typename?: 'Lot', id: string, name: string, buildAddress: { __typename?: 'Address', id: string, street1: string } }
        | { __typename?: 'Structure', id: string, name: string, buildAddress: { __typename?: 'Address', id: string, street1: string } }
        | { __typename?: 'Unit', id: string, name: string, buildAddress: { __typename?: 'Address', id: string, street1: string } }
      >, development?: { __typename?: 'Development', id: string, name: string } | null | undefined, developer?: { __typename?: 'InternalUser', id: string, name: string } | null | undefined }> } };

export type NameForDropdown_ScheduleTask_Fragment = { __typename?: 'ScheduleTask', id: string, name: string };

export type NameForDropdown_Approval_Fragment = { __typename?: 'Approval', id: string, name: string };

export type NameForDropdown_BidContract_Fragment = { __typename?: 'BidContract', id: string, name: string };

export type NameForDropdown_BidContractLineItem_Fragment = { __typename?: 'BidContractLineItem', id: string, name: string };

export type NameForDropdown_BidItem_Fragment = { __typename?: 'BidItem', id: string, name: string };

export type NameForDropdown_BidPackage_Fragment = { __typename?: 'BidPackage', id: string, name: string };

export type NameForDropdown_BidPackageRequest_Fragment = { __typename?: 'BidPackageRequest', id: string, name: string };

export type NameForDropdown_TradePartner_Fragment = { __typename?: 'TradePartner', id: string, name: string };

export type NameForDropdown_Bill_Fragment = { __typename?: 'Bill', id: string, name: string };

export type NameForDropdown_BusinessFunction_Fragment = { __typename?: 'BusinessFunction', id: string, name: string };

export type NameForDropdown_ChangeEvent_Fragment = { __typename?: 'ChangeEvent', id: string, name: string };

export type NameForDropdown_ChangeEventLineItem_Fragment = { __typename?: 'ChangeEventLineItem', id: string, name: string };

export type NameForDropdown_ChangeEventReason_Fragment = { __typename?: 'ChangeEventReason', id: string, name: string };

export type NameForDropdown_ChangeEventTemplateConfig_Fragment = { __typename?: 'ChangeEventTemplateConfig', id: string, name: string };

export type NameForDropdown_ChangeRequest_Fragment = { __typename?: 'ChangeRequest', id: string, name: string };

export type NameForDropdown_ChangeRequestAsset_Fragment = { __typename?: 'ChangeRequestAsset', id: string, name: string };

export type NameForDropdown_ChangeRequestToDo_Fragment = { __typename?: 'ChangeRequestToDo', id: string, name: string };

export type NameForDropdown_Client_Fragment = { __typename?: 'Client', id: string, name: string };

export type NameForDropdown_Cohort_Fragment = { __typename?: 'Cohort', id: string, name: string };

export type NameForDropdown_SchedulePhase_Fragment = { __typename?: 'SchedulePhase', id: string, name: string };

export type NameForDropdown_ScheduleSubPhase_Fragment = { __typename?: 'ScheduleSubPhase', id: string, name: string };

export type NameForDropdown_Task_Fragment = { __typename?: 'Task', id: string, name: string };

export type NameForDropdown_PlanTask_Fragment = { __typename?: 'PlanTask', id: string, name: string };

export type NameForDropdown_ToDo_Fragment = { __typename?: 'ToDo', id: string, name: string };

export type NameForDropdown_Invoice_Fragment = { __typename?: 'Invoice', id: string, name: string };

export type NameForDropdown_StandaloneProject_Fragment = { __typename?: 'StandaloneProject', id: string, name: string };

export type NameForDropdown_Region_Fragment = { __typename?: 'Region', id: string, name: string };

export type NameForDropdown_Market_Fragment = { __typename?: 'Market', id: string, name: string };

export type NameForDropdown_Community_Fragment = { __typename?: 'Community', id: string, name: string };

export type NameForDropdown_Subdivision_Fragment = { __typename?: 'Subdivision', id: string, name: string };

export type NameForDropdown_Lot_Fragment = { __typename?: 'Lot', id: string, name: string };

export type NameForDropdown_Structure_Fragment = { __typename?: 'Structure', id: string, name: string };

export type NameForDropdown_Unit_Fragment = { __typename?: 'Unit', id: string, name: string };

export type NameForDropdown_ProjectItem_Fragment = { __typename?: 'ProjectItem', id: string, name: string };

export type NameForDropdown_Estimate_Fragment = { __typename?: 'Estimate', id: string, name: string };

export type NameForDropdown_DevelopmentCommitment_Fragment = { __typename?: 'DevelopmentCommitment', id: string, name: string };

export type NameForDropdown_Commitment_Fragment = { __typename?: 'Commitment', id: string, name: string };

export type NameForDropdown_Document_Fragment = { __typename?: 'Document', id: string, name: string };

export type NameForDropdown_ItemTemplateItemVersion_Fragment = { __typename?: 'ItemTemplateItemVersion', id: string, name: string };

export type NameForDropdown_JobLogNote_Fragment = { __typename?: 'JobLogNote', id: string, name: string };

export type NameForDropdown_TradePartnerAvailabilityRequest_Fragment = { __typename?: 'TradePartnerAvailabilityRequest', id: string, name: string };

export type NameForDropdown_PunchlistItemTodo_Fragment = { __typename?: 'PunchlistItemTodo', id: string, name: string };

export type NameForDropdown_WarrantyTicket_Fragment = { __typename?: 'WarrantyTicket', id: string, name: string };

export type NameForDropdown_HomeownerContract_Fragment = { __typename?: 'HomeownerContract', id: string, name: string };

export type NameForDropdown_HomeownerContractChangeOrder_Fragment = { __typename?: 'HomeownerContractChangeOrder', id: string, name: string };

export type NameForDropdown_ReadyPlan_Fragment = { __typename?: 'ReadyPlan', id: string, name: string };

export type NameForDropdown_PlanPackage_Fragment = { __typename?: 'PlanPackage', id: string, name: string };

export type NameForDropdown_GlobalOption_Fragment = { __typename?: 'GlobalOption', id: string, name: string };

export type NameForDropdown_ProjectCostCode_Fragment = { __typename?: 'ProjectCostCode', id: string, name: string };

export type NameForDropdown_CommitmentChangeOrder_Fragment = { __typename?: 'CommitmentChangeOrder', id: string, name: string };

export type NameForDropdown_CostCode_Fragment = { __typename?: 'CostCode', id: string, name: string };

export type NameForDropdown_CostDivision_Fragment = { __typename?: 'CostDivision', id: string, name: string };

export type NameForDropdown_Customer_Fragment = { __typename?: 'Customer', id: string, name: string };

export type NameForDropdown_CustomerOwnerEntity_Fragment = { __typename?: 'CustomerOwnerEntity', id: string, name: string };

export type NameForDropdown_DesignPackage_Fragment = { __typename?: 'DesignPackage', id: string, name: string };

export type NameForDropdown_Development_Fragment = { __typename?: 'Development', id: string, name: string };

export type NameForDropdown_GlobalOptionTag_Fragment = { __typename?: 'GlobalOptionTag', id: string, name: string };

export type NameForDropdown_GlobalOptionType_Fragment = { __typename?: 'GlobalOptionType', id: string, name: string };

export type NameForDropdown_GlobalPlanConstraintItem_Fragment = { __typename?: 'GlobalPlanConstraintItem', id: string, name: string };

export type NameForDropdown_GlobalPlanMilestone_Fragment = { __typename?: 'GlobalPlanMilestone', id: string, name: string };

export type NameForDropdown_GlobalPlanTask_Fragment = { __typename?: 'GlobalPlanTask', id: string, name: string };

export type NameForDropdown_GlobalTask_Fragment = { __typename?: 'GlobalTask', id: string, name: string };

export type NameForDropdown_HomeownerContractDraw_Fragment = { __typename?: 'HomeownerContractDraw', id: string, name: string };

export type NameForDropdown_InternalUser_Fragment = { __typename?: 'InternalUser', id: string, name: string };

export type NameForDropdown_InvoiceScheduleTemplate_Fragment = { __typename?: 'InvoiceScheduleTemplate', id: string, name: string };

export type NameForDropdown_Item_Fragment = { __typename?: 'Item', id: string, name: string };

export type NameForDropdown_ItemSlot_Fragment = { __typename?: 'ItemSlot', id: string, name: string };

export type NameForDropdown_ItemTemplate_Fragment = { __typename?: 'ItemTemplate', id: string, name: string };

export type NameForDropdown_ItemTemplateItem_Fragment = { __typename?: 'ItemTemplateItem', id: string, name: string };

export type NameForDropdown_Location_Fragment = { __typename?: 'Location', id: string, name: string };

export type NameForDropdown_MaterialVariantTag_Fragment = { __typename?: 'MaterialVariantTag', id: string, name: string };

export type NameForDropdown_PandaDoc_Fragment = { __typename?: 'PandaDoc', id: string, name: string };

export type NameForDropdown_PandaDocRecipient_Fragment = { __typename?: 'PandaDocRecipient', id: string, name: string };

export type NameForDropdown_PlanMilestone_Fragment = { __typename?: 'PlanMilestone', id: string, name: string };

export type NameForDropdown_ProductOffering_Fragment = { __typename?: 'ProductOffering', id: string, name: string };

export type NameForDropdown_ProductOfferingStartingConfig_Fragment = { __typename?: 'ProductOfferingStartingConfig', id: string, name: string };

export type NameForDropdown_ProjectCustomItem_Fragment = { __typename?: 'ProjectCustomItem', id: string, name: string };

export type NameForDropdown_ProjectCustomOption_Fragment = { __typename?: 'ProjectCustomOption', id: string, name: string };

export type NameForDropdown_ProjectStageTemplateConfig_Fragment = { __typename?: 'ProjectStageTemplateConfig', id: string, name: string };

export type NameForDropdown_ProjectStatusChangeReason_Fragment = { __typename?: 'ProjectStatusChangeReason', id: string, name: string };

export type NameForDropdown_ReadyPlanAggregateVersion_Fragment = { __typename?: 'ReadyPlanAggregateVersion', id: string, name: string };

export type NameForDropdown_ReadyPlanLocation_Fragment = { __typename?: 'ReadyPlanLocation', id: string, name: string };

export type NameForDropdown_ReadyPlanOption_Fragment = { __typename?: 'ReadyPlanOption', id: string, name: string };

export type NameForDropdown_ReadyPlanOptionProgramDataModification_Fragment = { __typename?: 'ReadyPlanOptionProgramDataModification', id: string, name: string };

export type NameForDropdown_Schedule_Fragment = { __typename?: 'Schedule', id: string, name: string };

export type NameForDropdown_ScheduleTemplate_Fragment = { __typename?: 'ScheduleTemplate', id: string, name: string };

export type NameForDropdown_Submarket_Fragment = { __typename?: 'Submarket', id: string, name: string };

export type NameForDropdown_TakeoffLineItem_Fragment = { __typename?: 'TakeoffLineItem', id: string, name: string };

export type NameForDropdown_TakeoffLineItemVersion_Fragment = { __typename?: 'TakeoffLineItemVersion', id: string, name: string };

export type NameForDropdown_TradeCategory_Fragment = { __typename?: 'TradeCategory', id: string, name: string };

export type NameForDropdown_TradePartnerContact_Fragment = { __typename?: 'TradePartnerContact', id: string, name: string };

export type NameForDropdown_TradePartnerMailingList_Fragment = { __typename?: 'TradePartnerMailingList', id: string, name: string };

export type NameForDropdown_TradePartnerUser_Fragment = { __typename?: 'TradePartnerUser', id: string, name: string };

export type NameForDropdown_UnitOfMeasure_Fragment = { __typename?: 'UnitOfMeasure', id: string, name: string };

export type NameForDropdown_User_Fragment = { __typename?: 'User', id: string, name: string };

export type NameForDropdownFragment =
  | NameForDropdown_ScheduleTask_Fragment
  | NameForDropdown_Approval_Fragment
  | NameForDropdown_BidContract_Fragment
  | NameForDropdown_BidContractLineItem_Fragment
  | NameForDropdown_BidItem_Fragment
  | NameForDropdown_BidPackage_Fragment
  | NameForDropdown_BidPackageRequest_Fragment
  | NameForDropdown_TradePartner_Fragment
  | NameForDropdown_Bill_Fragment
  | NameForDropdown_BusinessFunction_Fragment
  | NameForDropdown_ChangeEvent_Fragment
  | NameForDropdown_ChangeEventLineItem_Fragment
  | NameForDropdown_ChangeEventReason_Fragment
  | NameForDropdown_ChangeEventTemplateConfig_Fragment
  | NameForDropdown_ChangeRequest_Fragment
  | NameForDropdown_ChangeRequestAsset_Fragment
  | NameForDropdown_ChangeRequestToDo_Fragment
  | NameForDropdown_Client_Fragment
  | NameForDropdown_Cohort_Fragment
  | NameForDropdown_SchedulePhase_Fragment
  | NameForDropdown_ScheduleSubPhase_Fragment
  | NameForDropdown_Task_Fragment
  | NameForDropdown_PlanTask_Fragment
  | NameForDropdown_ToDo_Fragment
  | NameForDropdown_Invoice_Fragment
  | NameForDropdown_StandaloneProject_Fragment
  | NameForDropdown_Region_Fragment
  | NameForDropdown_Market_Fragment
  | NameForDropdown_Community_Fragment
  | NameForDropdown_Subdivision_Fragment
  | NameForDropdown_Lot_Fragment
  | NameForDropdown_Structure_Fragment
  | NameForDropdown_Unit_Fragment
  | NameForDropdown_ProjectItem_Fragment
  | NameForDropdown_Estimate_Fragment
  | NameForDropdown_DevelopmentCommitment_Fragment
  | NameForDropdown_Commitment_Fragment
  | NameForDropdown_Document_Fragment
  | NameForDropdown_ItemTemplateItemVersion_Fragment
  | NameForDropdown_JobLogNote_Fragment
  | NameForDropdown_TradePartnerAvailabilityRequest_Fragment
  | NameForDropdown_PunchlistItemTodo_Fragment
  | NameForDropdown_WarrantyTicket_Fragment
  | NameForDropdown_HomeownerContract_Fragment
  | NameForDropdown_HomeownerContractChangeOrder_Fragment
  | NameForDropdown_ReadyPlan_Fragment
  | NameForDropdown_PlanPackage_Fragment
  | NameForDropdown_GlobalOption_Fragment
  | NameForDropdown_ProjectCostCode_Fragment
  | NameForDropdown_CommitmentChangeOrder_Fragment
  | NameForDropdown_CostCode_Fragment
  | NameForDropdown_CostDivision_Fragment
  | NameForDropdown_Customer_Fragment
  | NameForDropdown_CustomerOwnerEntity_Fragment
  | NameForDropdown_DesignPackage_Fragment
  | NameForDropdown_Development_Fragment
  | NameForDropdown_GlobalOptionTag_Fragment
  | NameForDropdown_GlobalOptionType_Fragment
  | NameForDropdown_GlobalPlanConstraintItem_Fragment
  | NameForDropdown_GlobalPlanMilestone_Fragment
  | NameForDropdown_GlobalPlanTask_Fragment
  | NameForDropdown_GlobalTask_Fragment
  | NameForDropdown_HomeownerContractDraw_Fragment
  | NameForDropdown_InternalUser_Fragment
  | NameForDropdown_InvoiceScheduleTemplate_Fragment
  | NameForDropdown_Item_Fragment
  | NameForDropdown_ItemSlot_Fragment
  | NameForDropdown_ItemTemplate_Fragment
  | NameForDropdown_ItemTemplateItem_Fragment
  | NameForDropdown_Location_Fragment
  | NameForDropdown_MaterialVariantTag_Fragment
  | NameForDropdown_PandaDoc_Fragment
  | NameForDropdown_PandaDocRecipient_Fragment
  | NameForDropdown_PlanMilestone_Fragment
  | NameForDropdown_ProductOffering_Fragment
  | NameForDropdown_ProductOfferingStartingConfig_Fragment
  | NameForDropdown_ProjectCustomItem_Fragment
  | NameForDropdown_ProjectCustomOption_Fragment
  | NameForDropdown_ProjectStageTemplateConfig_Fragment
  | NameForDropdown_ProjectStatusChangeReason_Fragment
  | NameForDropdown_ReadyPlanAggregateVersion_Fragment
  | NameForDropdown_ReadyPlanLocation_Fragment
  | NameForDropdown_ReadyPlanOption_Fragment
  | NameForDropdown_ReadyPlanOptionProgramDataModification_Fragment
  | NameForDropdown_Schedule_Fragment
  | NameForDropdown_ScheduleTemplate_Fragment
  | NameForDropdown_Submarket_Fragment
  | NameForDropdown_TakeoffLineItem_Fragment
  | NameForDropdown_TakeoffLineItemVersion_Fragment
  | NameForDropdown_TradeCategory_Fragment
  | NameForDropdown_TradePartnerContact_Fragment
  | NameForDropdown_TradePartnerMailingList_Fragment
  | NameForDropdown_TradePartnerUser_Fragment
  | NameForDropdown_UnitOfMeasure_Fragment
  | NameForDropdown_User_Fragment
;

export type ProjectForDropdown_StandaloneProject_Fragment = { __typename?: 'StandaloneProject', id: string, name: string, cohort?: { __typename?: 'Cohort', id: string } | null | undefined, market: { __typename?: 'Market', id: string } };

export type ProjectForDropdown_Region_Fragment = { __typename?: 'Region', id: string, name: string, cohort?: { __typename?: 'Cohort', id: string } | null | undefined, market?: { __typename?: 'Market', id: string } | null | undefined };

export type ProjectForDropdown_Market_Fragment = { __typename?: 'Market', id: string, name: string, cohort?: { __typename?: 'Cohort', id: string } | null | undefined, market: { __typename?: 'Market', id: string } };

export type ProjectForDropdown_Community_Fragment = { __typename?: 'Community', id: string, name: string, cohort?: { __typename?: 'Cohort', id: string } | null | undefined, market: { __typename?: 'Market', id: string } };

export type ProjectForDropdown_Subdivision_Fragment = { __typename?: 'Subdivision', id: string, name: string, cohort?: { __typename?: 'Cohort', id: string } | null | undefined, market: { __typename?: 'Market', id: string } };

export type ProjectForDropdown_Lot_Fragment = { __typename?: 'Lot', id: string, name: string, cohort?: { __typename?: 'Cohort', id: string } | null | undefined, market: { __typename?: 'Market', id: string } };

export type ProjectForDropdown_Structure_Fragment = { __typename?: 'Structure', id: string, name: string, cohort?: { __typename?: 'Cohort', id: string } | null | undefined, market: { __typename?: 'Market', id: string } };

export type ProjectForDropdown_Unit_Fragment = { __typename?: 'Unit', id: string, name: string, cohort?: { __typename?: 'Cohort', id: string } | null | undefined, market: { __typename?: 'Market', id: string } };

export type ProjectForDropdownFragment =
  | ProjectForDropdown_StandaloneProject_Fragment
  | ProjectForDropdown_Region_Fragment
  | ProjectForDropdown_Market_Fragment
  | ProjectForDropdown_Community_Fragment
  | ProjectForDropdown_Subdivision_Fragment
  | ProjectForDropdown_Lot_Fragment
  | ProjectForDropdown_Structure_Fragment
  | ProjectForDropdown_Unit_Fragment
;

export type CohortFormDetailFragment = { __typename?: 'Cohort', id: string, name: string, isBoolDefaultForDevelopment?: boolean | null | undefined, market: { __typename?: 'Market', id: string, name: string }, development?: { __typename?: 'Development', id: string, name: string } | null | undefined, projects: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
  > };

export type CohortDeveloperFragment = { __typename?: 'Cohort', id: string, developer?: { __typename?: 'InternalUser', id: string, name: string } | null | undefined };

export type MarketDetailFragment = { __typename?: 'Market', id: string, name: string };

export type CohortDetailFragment = { __typename?: 'Cohort', id: string, name: string, projects: Array<
    | { __typename?: 'StandaloneProject', id: string, buildAddress: { __typename?: 'Address', id: string, street1: string } }
    | { __typename?: 'Region', id: string, buildAddress?: { __typename?: 'Address', id: string, street1: string } | null | undefined }
    | { __typename?: 'Market', id: string, buildAddress?: { __typename?: 'Address', id: string, street1: string } | null | undefined }
    | { __typename?: 'Community', id: string, buildAddress?: { __typename?: 'Address', id: string, street1: string } | null | undefined }
    | { __typename?: 'Subdivision', id: string, buildAddress?: { __typename?: 'Address', id: string, street1: string } | null | undefined }
    | { __typename?: 'Lot', id: string, buildAddress: { __typename?: 'Address', id: string, street1: string } }
    | { __typename?: 'Structure', id: string, buildAddress: { __typename?: 'Address', id: string, street1: string } }
    | { __typename?: 'Unit', id: string, buildAddress: { __typename?: 'Address', id: string, street1: string } }
  >, development?: { __typename?: 'Development', id: string } | null | undefined, market: { __typename?: 'Market', id: string } };

export type CohortProject_StandaloneProject_Fragment = { __typename?: 'StandaloneProject', id: string, buildAddress: { __typename?: 'Address', id: string, street1: string } };

export type CohortProject_Region_Fragment = { __typename?: 'Region', id: string, buildAddress?: { __typename?: 'Address', id: string, street1: string } | null | undefined };

export type CohortProject_Market_Fragment = { __typename?: 'Market', id: string, buildAddress?: { __typename?: 'Address', id: string, street1: string } | null | undefined };

export type CohortProject_Community_Fragment = { __typename?: 'Community', id: string, buildAddress?: { __typename?: 'Address', id: string, street1: string } | null | undefined };

export type CohortProject_Subdivision_Fragment = { __typename?: 'Subdivision', id: string, buildAddress?: { __typename?: 'Address', id: string, street1: string } | null | undefined };

export type CohortProject_Lot_Fragment = { __typename?: 'Lot', id: string, buildAddress: { __typename?: 'Address', id: string, street1: string } };

export type CohortProject_Structure_Fragment = { __typename?: 'Structure', id: string, buildAddress: { __typename?: 'Address', id: string, street1: string } };

export type CohortProject_Unit_Fragment = { __typename?: 'Unit', id: string, buildAddress: { __typename?: 'Address', id: string, street1: string } };

export type CohortProjectFragment =
  | CohortProject_StandaloneProject_Fragment
  | CohortProject_Region_Fragment
  | CohortProject_Market_Fragment
  | CohortProject_Community_Fragment
  | CohortProject_Subdivision_Fragment
  | CohortProject_Lot_Fragment
  | CohortProject_Structure_Fragment
  | CohortProject_Unit_Fragment
;

export const NameForDropdownFragmentDoc = gql`
    fragment NameForDropdown on Named {
  id
  name
}
    `;
export const ProjectForDropdownFragmentDoc = gql`
    fragment ProjectForDropdown on Project {
  ...NameForDropdown
  cohort {
    id
  }
  market {
    id
  }
}
    ${NameForDropdownFragmentDoc}`;
export const CohortFormDetailFragmentDoc = gql`
    fragment CohortFormDetail on Cohort {
  id
  name
  isBoolDefaultForDevelopment
  market {
    id
    name
  }
  development {
    id
    name
  }
  projects {
    id
    name
  }
}
    `;
export const CohortDeveloperFragmentDoc = gql`
    fragment CohortDeveloper on Cohort {
  id
  developer {
    id
    name
  }
}
    `;
export const MarketDetailFragmentDoc = gql`
    fragment MarketDetail on Market {
  id
  name
}
    `;
export const CohortProjectFragmentDoc = gql`
    fragment CohortProject on Project {
  id
  buildAddress {
    id
    street1
  }
}
    `;
export const CohortDetailFragmentDoc = gql`
    fragment CohortDetail on Cohort {
  id
  name
  projects {
    ...CohortProject
  }
  development {
    id
  }
  market {
    id
  }
}
    ${CohortProjectFragmentDoc}`;
export const CohortDetailsForFormDocument = gql`
    query CohortDetailsForForm($cohortId: ID!) {
  cohort(id: $cohortId) {
    ...CohortFormDetail
  }
}
    ${CohortFormDetailFragmentDoc}`;

/**
 * __useCohortDetailsForFormQuery__
 *
 * To run a query within a React component, call `useCohortDetailsForFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useCohortDetailsForFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCohortDetailsForFormQuery({
 *   variables: {
 *      cohortId: // value for 'cohortId'
 *   },
 * });
 */
export function useCohortDetailsForFormQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CohortDetailsForFormQuery, CohortDetailsForFormQueryVariables> & ({ variables: CohortDetailsForFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CohortDetailsForFormQuery, CohortDetailsForFormQueryVariables>(CohortDetailsForFormDocument, options);
      }
export function useCohortDetailsForFormLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CohortDetailsForFormQuery, CohortDetailsForFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CohortDetailsForFormQuery, CohortDetailsForFormQueryVariables>(CohortDetailsForFormDocument, options);
        }
// @ts-ignore
export function useCohortDetailsForFormSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CohortDetailsForFormQuery, CohortDetailsForFormQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CohortDetailsForFormQuery, CohortDetailsForFormQueryVariables>;
export function useCohortDetailsForFormSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CohortDetailsForFormQuery, CohortDetailsForFormQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CohortDetailsForFormQuery | undefined, CohortDetailsForFormQueryVariables>;
export function useCohortDetailsForFormSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CohortDetailsForFormQuery, CohortDetailsForFormQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CohortDetailsForFormQuery, CohortDetailsForFormQueryVariables>(CohortDetailsForFormDocument, options);
        }
export type CohortDetailsForFormQueryHookResult = ReturnType<typeof useCohortDetailsForFormQuery>;
export type CohortDetailsForFormLazyQueryHookResult = ReturnType<typeof useCohortDetailsForFormLazyQuery>;
export type CohortDetailsForFormSuspenseQueryHookResult = ReturnType<typeof useCohortDetailsForFormSuspenseQuery>;
export type CohortDetailsForFormQueryResult = ApolloReactCommon.QueryResult<CohortDetailsForFormQuery, CohortDetailsForFormQueryVariables>;
export const PopulateCohortFormOptionsDocument = gql`
    query PopulateCohortFormOptions {
  markets {
    ...NameForDropdown
  }
  projects {
    ...ProjectForDropdown
  }
}
    ${NameForDropdownFragmentDoc}
${ProjectForDropdownFragmentDoc}`;

/**
 * __usePopulateCohortFormOptionsQuery__
 *
 * To run a query within a React component, call `usePopulateCohortFormOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePopulateCohortFormOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePopulateCohortFormOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePopulateCohortFormOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PopulateCohortFormOptionsQuery, PopulateCohortFormOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PopulateCohortFormOptionsQuery, PopulateCohortFormOptionsQueryVariables>(PopulateCohortFormOptionsDocument, options);
      }
export function usePopulateCohortFormOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PopulateCohortFormOptionsQuery, PopulateCohortFormOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PopulateCohortFormOptionsQuery, PopulateCohortFormOptionsQueryVariables>(PopulateCohortFormOptionsDocument, options);
        }
// @ts-ignore
export function usePopulateCohortFormOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PopulateCohortFormOptionsQuery, PopulateCohortFormOptionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PopulateCohortFormOptionsQuery, PopulateCohortFormOptionsQueryVariables>;
export function usePopulateCohortFormOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PopulateCohortFormOptionsQuery, PopulateCohortFormOptionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PopulateCohortFormOptionsQuery | undefined, PopulateCohortFormOptionsQueryVariables>;
export function usePopulateCohortFormOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PopulateCohortFormOptionsQuery, PopulateCohortFormOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PopulateCohortFormOptionsQuery, PopulateCohortFormOptionsQueryVariables>(PopulateCohortFormOptionsDocument, options);
        }
export type PopulateCohortFormOptionsQueryHookResult = ReturnType<typeof usePopulateCohortFormOptionsQuery>;
export type PopulateCohortFormOptionsLazyQueryHookResult = ReturnType<typeof usePopulateCohortFormOptionsLazyQuery>;
export type PopulateCohortFormOptionsSuspenseQueryHookResult = ReturnType<typeof usePopulateCohortFormOptionsSuspenseQuery>;
export type PopulateCohortFormOptionsQueryResult = ApolloReactCommon.QueryResult<PopulateCohortFormOptionsQuery, PopulateCohortFormOptionsQueryVariables>;
export const SaveCohortsDocument = gql`
    mutation SaveCohorts($cohorts: SaveCohortsInput!) {
  saveCohorts(input: $cohorts) {
    cohorts {
      ...CohortDetail
      ...CohortFormDetail
      ...CohortDeveloper
      market {
        ...MarketDetail
      }
    }
  }
}
    ${CohortDetailFragmentDoc}
${CohortFormDetailFragmentDoc}
${CohortDeveloperFragmentDoc}
${MarketDetailFragmentDoc}`;

/**
 * __useSaveCohortsMutation__
 *
 * To run a mutation, you first call `useSaveCohortsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCohortsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCohortsMutation, { data, loading, error }] = useSaveCohortsMutation({
 *   variables: {
 *      cohorts: // value for 'cohorts'
 *   },
 * });
 */
export function useSaveCohortsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveCohortsMutation, SaveCohortsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveCohortsMutation, SaveCohortsMutationVariables>(SaveCohortsDocument, options);
      }
export type SaveCohortsMutationHookResult = ReturnType<typeof useSaveCohortsMutation>;
export type SaveCohortsMutationResult = ApolloReactCommon.MutationResult<SaveCohortsMutation>;